import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from '../utils/baseQueryWithAuth';

// Api RTK Query pour le dashboard
export const dashboardApi = createApi({
  reducerPath: 'dashboardApi',
  baseQuery: baseQueryWithAuth,
  tagTypes: ['DashboardSalon', 'DashboardGlobal'],
  endpoints: (builder) => ({
    // Endpoint pour le dashboard d'un salon spécifique
    dashboardSalon: builder.query({
      query: ({ salonId }) => `/api/dashboard/salon/${salonId}/`,
      providesTags: (result, error, arg) => [{ type: 'DashboardSalon', id: arg.salonId }]
    }),
    
    // Endpoint pour le dashboard global (tous les salons)
    dashboardGlobal: builder.query({
      query: () => `/api/dashboard/global/`,
      providesTags: ['DashboardGlobal']
    }),
  }),
});

// Export des hooks générés automatiquement
export const {
  useDashboardSalonQuery,
  useDashboardGlobalQuery
} = dashboardApi;
